import { PhoneTypes } from '../../../interfaces/enums/phone-types.enum';

export const PHONE_TYPES_TRANSLATION = new Map<PhoneTypes, string>([
    [PhoneTypes.office, 'PROFILE_COMMON.ENUM_TYPES.office'],
    [PhoneTypes.home, 'PROFILE_COMMON.ENUM_TYPES.home'],
    [PhoneTypes.mobile, 'PROFILE_COMMON.ENUM_TYPES.mobile'],
    [PhoneTypes.other, 'PROFILE_COMMON.ENUM_TYPES.other'],
]);